/**
 * @typedef OzkConfig
 * @property {string} Environment
 * @property {string} MarketoToken
 * @property {string} MarketoUrl
 * @property {string} MarketoFormId
 * @property {string} GoogleMapsApiKey
 * @property {string} TagManagerId
 * @property {string} BlogUrl
 * @property {string} FuncApiUrl
 * @property {string} FuncGetAlerts
 * @property {string} FuncGetBranches
 * @property {string} FuncSaveLoanDeferral
 * @property {string} FuncSaveOnlineBankingBusinessEnrollment
 * @property {string} AppInsightsConnectionString
 * @property {string} OptimizeId
 * @property {string} OptimizeWait
 * @property {string} GuardianSrc
 * @property {string} HubEnv
 * @property {string} HubForgotPw
 * @property {string} HubEnroll
 * @property {string} StorageUrl
 * @property {string} OnboardUrl
 * @property {string} Robots
 * @property {string} Q2Endpoint
 *
 * @property {string} ContentStackApiKey
 * @property {string} ContentStackApiHost
 * @property {string} ContentStackPreviewHost
 * @property {string} ContentStackPreviewToken
 * @property {string} ContentStackDeliveryToken
 * @property {string} ContentStackEnvironment
 * @property {string} ContentStackLivePreview
 */

/** @type {OzkConfig} */
export const config = {
	Environment: process.env.GATSBY_ENVIRONMENT,
	MarketoToken: process.env.GATSBY_MARKETO_TOKEN,
	MarketoUrl: process.env.GATSBY_MARKETO_URL,
	MarketoFormId: process.env.GATSBY_MARKETO_FORM_ID,
	GoogleMapsApiKey: process.env.GATSBY_GOOGLE_MAPS_API_KEY,
	TagManagerId: process.env.GATSBY_TAG_MANAGER_ID,
	BlogUrl: process.env.GATSBY_BLOG_URL,
	FuncApiUrl: process.env.GATSBY_FUNC_API_URL,
	FuncGetAlerts: process.env.GATSBY_FUNC_GET_ALERTS,
	FuncGetBranches: process.env.GATSBY_FUNC_GET_BRANCHES,
	FuncSaveLoanDeferral: process.env.GATSBY_FUNC_SAVE_LOAN_DEFERRAL,
	FuncSaveOnlineBankingBusinessEnrollment: process.env.GATSBY_FUNC_SAVE_ONLINE_BANKING_BUSINESS_ENROLLMENT,
	AppInsightsConnectionString: process.env.GATSBY_APP_INSIGHTS_CONNECTION_STRING,
	OptimizeId: process.env.GATSBY_OPTIMIZE_ID,
	OptimizeWait: process.env.GATSBY_OPTIMIZE_WAIT,
	GuardianSrc: process.env.GATSBY_GUARDIAN_SRC,
	HubEnv: process.env.GATSBY_HUB_ENV,
	HubForgotPw: process.env.GATSBY_HUB_FORGOT_PW,
	HubEnroll: process.env.GATSBY_HUB_ENROLL,
	StorageUrl: process.env.GATSBY_STORAGE_URL,
	OnboardUrl: process.env.GATSBY_ONBOARD_URL,
	Robots: process.env.GATSBY_ROBOTS,
	Q2Endpoint: process.env.GATSBY_Q2_ENDPOINT,

	ContentStackApiKey: process.env.GATSBY_CONTENT_STACK_API_KEY,
	ContentStackApiHost: process.env.GATSBY_CONTENT_STACK_API_HOST,
	ContentStackPreviewHost: process.env.GATSBY_CONTENT_STACK_PREVIEW_HOST,
	ContentStackPreviewToken: process.env.GATSBY_CONTENT_STACK_PREVIEW_TOKEN,
	ContentStackDeliveryToken: process.env.GATSBY_CONTENT_STACK_DELIVERY_TOKEN,
	ContentStackEnvironment: process.env.GATSBY_CONTENT_STACK_ENVIRONMENT,
	ContentStackLivePreview: process.env.GATSBY_CONTENT_STACK_LIVE_PREVIEW,
};
export default config;
